// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import { Header } from "@dip/helsecore/src/components/shared/Header/Header";
import type { HeaderProps } from "@dip/helsecore/src/main/resources/site/mixins/helsecoreHeader/helsecoreHeader.d"

export default (props: Readonly<HeaderProps>) => <Header {...props} />
